export default __webpack_public_path__ + "static/media/Mr. Smarajeet Singh.d593603f.png";